import React, { Component } from 'react';
import { Spin, Table, Tooltip, Button, Card, Icon, InputNumber, Select, Modal } from 'antd';
import moment from 'moment';
import { openNotification } from '../../util/notificaciones';
import CapturaCiclicaRequest from '../../services/CapturaCiclica';
import MotivosRequest from '../../services/Motivos';
import { Link } from 'react-router-dom';
const { confirm } = Modal;
const { Option } = Select;
const exceptThisSymbols = ["e", "E", "+", "-"];


document.addEventListener("wheel", function (event) {
    if (document.activeElement.type === "number") {
        document.activeElement.blur();
    }
});

export default class CapturaCiclica extends Component {
    state = {
        cargando: false,
        guardando: false,
        registrando: false,
        inventario: null,
        lineas: [],
        motivos: [],
        fechaUltimaSincronizacion: null,
        width: window.screen.width,
        procesandoId: null,
        asignandoMotivoId: null,
    }

    componentDidMount = () => {
        this.cargarCaptura()
        MotivosRequest.ListarMotivos().then(response => {
            this.setState({ motivos: response.data?.results || response.data || [] })
        }).catch(() => { })
    }

    calcularConteoTotalPreview = (linea) => {
        const bodega = Number(linea.existencia_bodega) || 0
        const cocina = Number(linea.existencia_cocina) || 0
        return bodega + cocina
    }

    cargarCaptura = () => {
        const { idInventario } = this.props.match.params
        this.setState({ cargando: true }, () => {
            CapturaCiclicaRequest.ObtenerCaptura(idInventario).then(response => {
                const lineas = (response.data.detalles || []).map(item => ({
                    ...item,
                    conteo_total_preview: item.procesado ? item.conteo_total : this.calcularConteoTotalPreview(item),
                }))
                this.setState({
                    cargando: false,
                    inventario: response.data.inventario,
                    lineas,
                    fechaUltimaSincronizacion: response.data.fecha_ultima_sincronizacion,
                })
            }).catch(err => {
                this.setState({ cargando: false })
                openNotification(err?.response?.data?.message, 'Error')
            })
        })
    }

    onChangeExistencia = (campo, value, record) => {
        this.setState(prevState => {
            const lineas = prevState.lineas.map(item => {
                if (item.id !== record.id) return item
                const actualizado = { ...item, [campo]: value === undefined ? null : value }
                if (!actualizado.procesado) {
                    actualizado.conteo_total_preview = this.calcularConteoTotalPreview(actualizado)
                }
                return actualizado
            })
            return { lineas }
        })
    }

    procesarLinea = (record) => {
        const payload = {
            existencia_bodega: record.existencia_bodega,
            existencia_cocina: record.existencia_cocina,
        }

        this.setState({ procesandoId: record.id }, () => {
            CapturaCiclicaRequest.ProcesarLinea(this.state.inventario.id, record.id, payload).then(response => {
                this.setState(prevState => ({
                    lineas: prevState.lineas.map(item => item.id === record.id ? response.data : item),
                    procesandoId: null
                }))
            }).catch(err => {
                this.setState({ procesandoId: null })
                openNotification(err?.response?.data?.message, 'Error')
            })
        })
    }

    onChangeMotivo = (value, record) => {
        this.setState({ asignandoMotivoId: record.id }, () => {
            CapturaCiclicaRequest.AsignarMotivo(this.state.inventario.id, record.id, { id_motivo_diferencia: value }).then(response => {
                this.setState(prevState => ({
                    lineas: prevState.lineas.map(item => item.id === record.id ? response.data : item),
                    asignandoMotivoId: null
                }))
            }).catch(err => {
                this.setState({ asignandoMotivoId: null })
                openNotification(err?.response?.data?.message, 'Error')
            })
        })
    }

    guardarBorrador = () => {
        const lineas = this.state.lineas
            .filter(item => !item.procesado)
            .map(({ id, existencia_bodega, existencia_cocina }) => ({ id, existencia_bodega, existencia_cocina }))

        this.setState({ guardando: true }, () => {
            CapturaCiclicaRequest.GuardarBorrador(this.state.inventario.id, lineas).then(() => {
                openNotification("Borrador guardado correctamente.", "Éxito")
                this.setState({ guardando: false }, this.cargarCaptura)
            }).catch(err => {
                this.setState({ guardando: false })
                openNotification(err?.response?.data?.message, 'Error')
            })
        })
    }

    confirmarRegistrar = () => {
        confirm({
            title: 'Confirmar',
            content: <div><b>¿Está seguro que las cantidades capturadas son las correctas?</b></div>,
            okText: 'Aceptar',
            cancelText: 'Cancelar',
            onOk: () => this.registrar(),
        });
    }

    registrar = () => {
        this.setState({ registrando: true }, () => {
            CapturaCiclicaRequest.Registrar(this.state.inventario.id).then(() => {
                openNotification("Inventario cíclico registrado correctamente.", "Éxito")
                this.props.history.push(`/inventario_ciclico_diferencias/${this.props.match.params.idSitio}`)
            }).catch(err => {
                this.setState({ registrando: false })
                openNotification(err?.response?.data?.message, 'Error')
            })
        })
    }

    financial(x) {
        if (x === null || x === undefined || x === '') return '-'
        return Number.parseFloat(x).toFixed(2);
    }

    getRowClassName = (record, index) => {
        const clases = []

        const anterior = this.state.lineas[index - 1]
        if (anterior && !anterior.es_adicional && record.es_adicional) {
            clases.push('ciclico-separador')
        }

        return clases.join(' ')
    };

    render() {
        const { inventario, lineas } = this.state
        const rutaRegreso = `/inventario_ciclico_diferencias/${this.props.match.params.idSitio}`
        const puedeEditar = inventario?.estado === 'Borrador'
        const lineasBase = lineas.filter(l => !l.es_adicional)
        const totalLineas = lineasBase.length
        const lineasProcesadas = lineasBase.filter(l => l.procesado).length

        let tituloFrecuencia = '';
        if (inventario) {
            if (inventario.tipo_frecuencia === 'diario') {
                tituloFrecuencia = `- Diario (${inventario.turno_nombre})`;
            } else {
                tituloFrecuencia = '- Semanal';
            }
        }

        let tooltipRegistrarText = '';
        if (lineasProcesadas < totalLineas) {
            tooltipRegistrarText = `Faltan ${totalLineas - lineasProcesadas} de ${totalLineas} líneas por procesar`;
        }

        const columnas = [
            { title: "Código PT", dataIndex: "codigo_articulo", key: "codigo_articulo", width: 120, show: true },
            { title: "Descripción", dataIndex: "descripcion", key: "descripcion", show: true },
            { title: "Unidad", dataIndex: "unidad_medida", key: "unidad_medida", align: 'center', width: 90, show: this.state.width > 800 },
            {
                title: "Inventario inicial",
                dataIndex: "existencia_teorica",
                key: "existencia_teorica",
                align: 'center',
                show: this.state.width > 800,
                render: (value) => <span>{this.financial(value)}</span>
            },
            {
                title: "Existencia Bodega",
                dataIndex: "existencia_bodega",
                key: "existencia_bodega",
                align: 'center',
                width: 130,
                show: true,
                render: (_, record) => (
                    <InputNumber
                        type="number"
                        onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                        min={0} max={99999} precision={4}
                        value={record.existencia_bodega}
                        disabled={!puedeEditar || record.procesado}
                        onChange={(value) => this.onChangeExistencia('existencia_bodega', value, record)}
                    />
                )
            },
            {
                title: "Existencia Cocina",
                dataIndex: "existencia_cocina",
                key: "existencia_cocina",
                align: 'center',
                width: 130,
                show: true,
                render: (_, record) => (
                    <InputNumber
                        type="number"
                        onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                        min={0} max={99999} precision={4}
                        value={record.existencia_cocina}
                        disabled={!puedeEditar || record.procesado}
                        onChange={(value) => this.onChangeExistencia('existencia_cocina', value, record)}
                    />
                )
            },
            {
                title: <Tooltip title="Suma de conteo de bodega + cocina">Conteo Total</Tooltip>,
                dataIndex: "conteo_total",
                key: "conteo_total",
                align: 'center',
                show: true,
                render: (value, record) => (
                    <span>{this.financial(record.procesado ? value : record.conteo_total_preview)}</span>
                )
            },
            {
                title: <Tooltip title="Conteo total - Inventario inicial">Diferencia</Tooltip>,
                dataIndex: "diferencia",
                key: "diferencia",
                align: 'center',
                show: true,
                render: (value) => <span>{this.financial(value)}</span>
            },
            // {
            //     title: "Motivo",
            //     dataIndex: "motivo_diferencia_id",
            //     key: "motivo_diferencia_id",
            //     width: 200,
            //     show: true,
            //     render: (_, record) => {
            //         if (!(record.procesado && Number(record.diferencia) !== 0)) return null

            //         const opciones = record.motivo_diferencia_id
            //             ? [
            //                 { id: record.motivo_diferencia_id, descripcion: record.motivo_diferencia_nombre || 'Motivo no disponible' },
            //                 ...this.state.motivos.filter(m => m.id !== record.motivo_diferencia_id)
            //             ]
            //             : this.state.motivos

            //         return (
            //             <Select
            //                 style={!record.motivo_diferencia_id ? { width: '100%', border: '1px solid #f5222d', borderRadius: 4 } : { width: '100%' }}
            //                 value={record.motivo_diferencia_id || undefined}
            //                 placeholder="Pendiente: selecciona un motivo"
            //                 disabled={!puedeEditar || this.state.asignandoMotivoId === record.id}
            //                 loading={this.state.asignandoMotivoId === record.id}
            //                 onChange={(value) => this.onChangeMotivo(value, record)}
            //             >
            //                 {opciones.map(m => <Option key={m.id} value={m.id}>{m.descripcion}</Option>)}
            //             </Select>
            //         )
            //     }
            // },
            {
                title: 'Acción',
                dataIndex: 'accion',
                key: 'accion',
                width: 90,
                show: true,
                render: (_, record) => {
                    if (record.procesado) {
                        return <Tooltip title="Línea procesada"><Icon type="check-circle" style={{ color: '#008F39', fontSize: 18 }} /></Tooltip>
                    }

                    const listoParaProcesar = puedeEditar
                        && record.existencia_bodega !== null && record.existencia_bodega !== undefined
                        && record.existencia_cocina !== null && record.existencia_cocina !== undefined

                    return (
                        <Tooltip title={listoParaProcesar ? "Procesar línea" : "Captura ambas existencias para poder procesar"}>
                            <Button
                                icon="calculator"
                                loading={this.state.procesandoId === record.id}
                                disabled={!listoParaProcesar || this.state.procesandoId === record.id}
                                onClick={() => this.procesarLinea(record)}
                            ></Button>
                        </Tooltip>
                    )
                }
            },
        ].filter(columna => columna.show === true)

        return (
            <Card id="ParentSize"
                title={
                    <div>
                        <Tooltip placement="top" title="Regresar">
                            <Link to={rutaRegreso}>
                                <Icon type="arrow-left" style={{ fontSize: '22px', color: '#91ba43' }} theme="outlined" />
                            </Link>
                        </Tooltip> &nbsp; Captura de inventario cíclico {tituloFrecuencia}
                    </div>
                }
                extra={
                    <div>
                        {puedeEditar && <React.Fragment>
                            <Button className="btnVerCrearGuardar"
                                loading={this.state.guardando}
                                type="primary"
                                onClick={this.guardarBorrador}
                            > Guardar Borrador </Button>&nbsp;
                            <Tooltip title={tooltipRegistrarText}>
                                <Button className="btnVerCrearGuardar"
                                    disabled={lineasProcesadas < totalLineas}
                                    loading={this.state.registrando}
                                    type="primary"
                                    onClick={this.confirmarRegistrar}
                                > Registrar </Button>
                            </Tooltip>
                        </React.Fragment>}
                    </div>
                }
            >
                <div className="panel-block">
                    <div style={{ textAlign: 'right', fontSize: 14, color: '#888', marginBottom: 8 }}>
                        {this.state.fechaUltimaSincronizacion
                            ? `Última actualización de inventario inicial: ${moment(this.state.fechaUltimaSincronizacion).format("DD/MM/YYYY, h:mm a")}`
                            : 'Sin información de última actualización'}
                    </div>
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table size="small"
                            className="tabla-captura-ciclica"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            rowKey={record => record.id}
                            columns={columnas}
                            dataSource={lineas}
                            rowClassName={this.getRowClassName}
                            pagination={false}
                            scroll={{ ...(this.state.width > 800 ? { x: 1200 } : {}), y: 'calc(100vh - 250px)' }}
                        />
                    </Spin>
                </div>
            </Card>
        )
    }
}
